// This file was auto-generated by Fern from our API Definition.
const AvailabilityStatusValues = {
    InDevelopment: "IN_DEVELOPMENT",
    PreRelease: "PRE_RELEASE",
    GeneralAvailability: "GENERAL_AVAILABILITY",
    Deprecated: "DEPRECATED",
};
export const AvailabilityStatus = Object.assign(Object.assign({}, AvailabilityStatusValues), { _visit: (value, visitor) => {
        switch (value) {
            case AvailabilityStatus.InDevelopment:
                return visitor.inDevelopment();
            case AvailabilityStatus.PreRelease:
                return visitor.preRelease();
            case AvailabilityStatus.GeneralAvailability:
                return visitor.generalAvailability();
            case AvailabilityStatus.Deprecated:
                return visitor.deprecated();
            default:
                return visitor._other();
        }
    } });
